import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import StyledLoadingSpinner from "../ui/StyledLoadingSpinner";
import bannerImg from "../../../src/assets/images/league-default-image.png";
import { getUserDetails, updateLeagueTeams } from "./firestoreQuery";
import { IUserDetails } from "../../types/leagueLocker";
import { set } from "lodash";

interface JoinLeagueProps {
  leagueData: any;
  onJoinSuccess?: (leagueData: any) => void;
  onJoinError?: (error: string) => void;
}

const JoinLeague: React.FC<JoinLeagueProps> = ({
  leagueData,
  onJoinSuccess,
  onJoinError,
}) => {
  const { user } = useAuth();
  const [isJoining, setIsJoining] = useState(false);

 
  const [creatorDetails, setCreatorDetails] = useState<any>(null);
  const [userDetails, setUserDetails] = useState<IUserDetails | null>(null);

  useEffect(() => {
    if (leagueData) {
      
      leagueData.teams = leagueData.teams || [];
      // check leagueData.teams already have createdBy === user?.uid
      const userAlreadyInLeague = leagueData.teams.some(
        (team: any) => team.createdBy === user?.uid
      );
      if (userAlreadyInLeague) {
        window.location.href = `/${leagueData.leagueUrl}/feed`;
      }
    }
    console.log("League Data in Join page:", leagueData);
  }, [leagueData]);

  useEffect(() => {
    /*
     * Fetch createdBy user details
     */
    if (leagueData?.createdBy) {
      getUserDetails(leagueData.createdBy)
        .then((userDetails) => {
          if (userDetails) {
            console.log("League created by:", userDetails.name);
            setCreatorDetails(userDetails);
          }
        })
        .catch((error) => {
          console.error("Error fetching user details:", error);
        });
    }
  }, [leagueData?.createdBy]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (user) {
        const userRes = await getUserDetails(user?.uid);
        userRes && setUserDetails(userRes as IUserDetails);
      }
    };
    fetchUserDetails();
  }, []);

  // Helper function to check if league has available spots
  const hasAvailableSpots = () => {
    if (!leagueData) return false;
    
    const leagueSize = Number(leagueData.leagueSize) || 0;
    const teams = leagueData.teams || [];
    const currentTeamCount = teams.length;
    
    return currentTeamCount < leagueSize;
  };




  const handleJoinLeague = async () => {
      if (!userDetails && !leagueData) return;
      
      try {
        setIsJoining(true);
        const teamData = {
          name:
            userDetails && userDetails.name
              ? `${userDetails.name}'s Team`
              : user?.displayName
              ? `${user.displayName}'s Team`
              : "New Team",
          createdBy: user?.uid || "",
          joinedAt: new Date().toISOString(),
        };

        const updatedLeague = await updateLeagueTeams(leagueData.id, teamData);
        console.log("Updated League after joining:", updatedLeague);
        if (!updatedLeague.success) {
          onJoinError && onJoinError(updatedLeague.message);
        } else {
          localStorage.removeItem("joinCode");
          onJoinSuccess && onJoinSuccess(updatedLeague.message);
        }
        
      } catch (err) {
        console.error("Error joining league:", err);
      } finally {
        setIsJoining(false);
      }
    };

    const invitorName = ()=>{
      let name = ''
      const invitorTeam = leagueData.teams.filter(
        (team: any) => team.createdBy === leagueData.createdBy
      );
      // creatorDetails?.name
      if (invitorTeam[0].name){
        if(invitorTeam[0].name.toLowerCase().includes("commissioner")){
          name = creatorDetails?.name;
        } else {
          name = invitorTeam[0].name;
        }
      } else {
        name = creatorDetails.name || creatorDetails.displayName;
      }
      return name;
    }

  return (
    <div className="contentArea otherContentArea">
      <div className="wrapper txtCenter">
        <div className="pageHeading">You've Been Invited!</div>
        <div className="subHeading">
          <strong>
            {invitorName() || "League Commissioner"}
          </strong>
          , has invited you to join a league
        </div>
        <div className="innerBanner bottomGap0">
          <img src={leagueData.bannerImage || bannerImg} alt="" />
          <div className="innerBannerContent contentCenter">
            <div className="bannerTitle">
              {leagueData?.leagueName || "Fantasy League"}
            </div>
            <p>
              { leagueData?.leagueBio ||
                "Join us for an exciting fantasy season!"}
            </p>
            {hasAvailableSpots() ? (
              <button
                className="btnStyle btnHighlighted btnInline"
                onClick={handleJoinLeague}
                disabled={isJoining}
              >
                {isJoining ? "JOINING..." : "JOIN THE LEAGUE"}
              </button>
            ) : (
              <div className="btnStyle btnDisabled btnInline">
                ALL PLACES FILLED
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinLeague;
